import { Navigate } from 'react-router-dom';
import { useContext } from 'react';
import { GlobalContext } from 'Context/GlobalContext/AppContext';

const PrivateRoute = ({ children }) => {
  const { user } = useContext(GlobalContext);

  if (!user.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;